import {
  CONTENIDOS_HAS_ERRORED,
  CONTENIDOS_IS_LOADING,
  SET_CONTENIDOS,
  SET_SLIDERS_HOME,
  SET_LINK_INCENTIVOS
} from "../actions/aContenidos";
import { handleActions } from 'redux-actions'

const initialState = {
  contenidosIsLoading: false,
  contenidosHasError: false,
  contenidos: [],
  slidersHome: [],  
};

export const datosContenido = (state = initialState, action) => {  
  switch (action.type) {
    case CONTENIDOS_HAS_ERRORED:
      return {
        ...state,
        contenidosIsLoading: false,
        contenidosHasError: true,
      };

    case CONTENIDOS_IS_LOADING:
      return {
        ...state,
        contenidosIsLoading: true,
        contenidosHasError: false,
      };

    case SET_CONTENIDOS:
      return {
        ...state,
        contenidos:
          action.payload /* {...state.contenidos,...action.payload},  */,
        contenidosIsLoading: false,
        contenidosHasError: false,
      };
    case SET_SLIDERS_HOME:
      return {
        ...state,
        slidersHome: [...state.slidersHome, ...action.payload],
      };
    default:
      return state;
  }
};

// export default datosContenido;


export const dataIncentivos = handleActions(
  {
    [SET_LINK_INCENTIVOS]: (state, action) => ({ ...state, linkIncentivos: action.payload}),
  },
  {
    linkIncentivos:""
  }
);
